import React, { useState, useRef } from 'react'
import { Modal, Row, Col, FormControl, FormLabel, Form } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'
import DatePicker from "react-datepicker"
import moment from 'moment';
import { Tooltip, IconButton } from '@material-ui/core'
import { BsPencil } from 'react-icons/bs'
import Select from 'react-select'



export default function PreviewDescription(props) {
  const MAX_FILE_SIZE_GB = 2

  const tags = props.tags
  const sections = props.sections
  const deSection = sections ? (props.sections || []).find(sec => sec.sectionName === (props.open.val || {}).section) : undefined
  const [loading, setLoading] = useState(false)
  const [description, setDescription] = useState("")
  const [title, setTitle] = useState("")
  const [newVideoOutOfTime, setNewVideoOutOfTime] = useState(new Date())
  const [time, setTime] = useState(undefined)
  const [tag, setTag] = useState([])
  const [section, setSection] = useState(undefined)
  const [file, setFile] = useState('')
  const [fileImage, setFileImage] = useState('')

  const refImg = useRef<HTMLInputElement>(null)

  const handleChange = (event) => {
    const img = event.target.files[0]

    if (!img) return

    if (img.size > MAX_FILE_SIZE_GB * 1024 * 1024 * 1024) {
      alert(`File size exceeds ${MAX_FILE_SIZE_GB} GB limit`)
      if (refImg.current) refImg.current.value = ""
      return
    }

    setFile(event.target.files[0])
    setFileImage(event.target.files[0].name)
  }

  React.useEffect(() => {
    const DATE = props.open.val ? new Date(moment(props.open.val.newVideoOutOfTime).format("YYYY/MM/DD")) : new Date()
    setNewVideoOutOfTime(DATE)
    setTitle((props.open.val || {}).title)
    setDescription((props.open.val || {}).description)
    setSection(deSection)
    setTag(((props.open || {})._tags || []).filter(_ => _))
  }, // eslint-disable-next-line
    [props.open.val])

  const onModalConfirm = async () => {
    setLoading(true)

    const files = new FormData()
    files.append(`sampleFile`, file)

    const _tags = tag.map(item => item.tagname)
    const _sectionnew = section ? section.sectionName : undefined

    let data = {
      id: (props.open.val || {}).id,
      description,
      title,
      newVideoOutOfTime,
      section: _sectionnew,
      tag: JSON.stringify(_tags),
    }

    const result = await ajax.postFormData(`/video/update/des?id=${data.id}&description=${data.description}&title=${data.title}&newVideoOutOfTime=${data.newVideoOutOfTime}&section=${data.section}&tag=${data.tag}`, files)
    setDescription(undefined)
    setTitle(undefined)
    setFileImage('')
    props.callback(result)
    setLoading(false)
  }
  //! date 
  const setFrom = (e: any) => {
    setNewVideoOutOfTime(e)
    setTime(e)
  }

  const handleTags = (value, { action, removedValue }) => {
    switch (action) {
      case 'remove-value':
        setTag(value)
        break;
      case 'select-option':
        setTag(value)
        break;
      case 'clear':
        setTag([])
        break;
    }
  }

  return (
    <Modal show={props.open.show} >
      <Modal.Header>
        <Modal.Title>Change Description</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.File id="formcheck-api-custom" custom style={{ display: "none" }} >
          <Form.File.Input isValid={true} ref={refImg} accept="image/*" onChange={handleChange} />
        </Form.File>
        <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Thumbnail</FormLabel></Col>
          <Col xs={5} sm={7} style={{ display: "flex", alignItems: "flex-end" }} >
            <Button variant="outline-secondary"
              style={{ marginTop: '5px' }}
              onClick={() => refImg.current.click()}
              disabled={loading}>
              Browse
            </Button>
            <span style={{ marginLeft: '5px' }} >{fileImage}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>New Title</FormLabel></Col>
          <Col xs={5} sm={7}>
            <FormControl type="text" name="title" style={{ marginTop: '5px' }} value={title || ""} onChange={(e) => setTitle(e.target.value)} />
          </Col>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>New Description</FormLabel></Col>
          <Col xs={5} sm={7}>
            <FormControl type="text" as="textarea" rows={3} name="description" style={{ marginTop: '5px' }} value={description || ""} onChange={(e) => setDescription(e.target.value)} />
          </Col>
        </Row>
        <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>New Video Day</FormLabel></Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <DatePicker minDate={new Date()} selected={newVideoOutOfTime} dateFormat="dd/MM/yyyy" onChange={date => setFrom(date)} />
          </Col>
        </Row>
        <Row>
          <Col xs={5} sm={4}>
            <FormLabel style={{ marginTop: '6px' }}>
              Section
              <Tooltip title="Edit Section" aria-label="add">
                <IconButton aria-label="delete" style={{ marginLeft: "3px" }} onClick={() => props.handleData("Section", "edit", props.open.val)}>
                  <BsPencil style={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </FormLabel>
          </Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <Select
              className="basic-single"
              classNamePrefix="select"
              onChange={e => setSection(e)}
              isClearable
              defaultValue={deSection}
              isSearchable
              name="section"
              options={sections}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={5} sm={4}>
            <FormLabel style={{ marginTop: '6px' }}>
              Tag
              <Tooltip title="Edit Tag" aria-label="add">
                <IconButton aria-label="delete" onClick={() => props.handleData("Tag", "edit", props.open.val)} style={{ marginLeft: "3px" }} >
                  <BsPencil style={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </FormLabel>
          </Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <Select
              className="basic-single"
              classNamePrefix="select"
              isMulti
              defaultValue={(props.open || {})._tags}
              onChange={handleTags}
              isClearable
              isSearchable
              name="tag"
              options={tags}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="success"
          loading={loading}
          onClick={onModalConfirm}
          disabled={
            (description || "").length === 0
            && (title || "").length === 0
            && time === undefined
            && section === undefined
            && (tag || []).length === 0
          }>
          {loading ? 'Please wait' : 'Save'}
        </Button>
        <Button bsStyle="default" onClick={() => props.callback()}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}